import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

const articleImages: Record<string, string> = {
  'article-1': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20registration%20form%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20signup%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic&width=600&height=350&seq=article-card-1&orientation=landscape',
  'article-2': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20login%20screen%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20authentication%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic&width=600&height=350&seq=article-card-2&orientation=landscape',
  'article-3': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20cybersecurity%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20lock%20shield%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic&width=600&height=350&seq=article-card-3&orientation=landscape',
  'article-4': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20announcement%20megaphone%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20update%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic&width=600&height=350&seq=article-card-4&orientation=landscape',
};

export default function ArticleSection() {
  const featuredArticles = articles.slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 md:mb-16 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              精选文章推荐
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base">
              最新、最实用的平台使用指南与资讯
            </p>
          </div>
          <Link
            to="/category/tutorial"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-background-50/90 text-primary-600 whitespace-nowrap">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-auto pt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}